(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/helpers/math.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/helpers/math.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.helpers.Math = Marionette.MnObject.extend({
    factorial: function(number) {
      var rval = 1;

      for (var i = 2; i <= number; i++) {
        rval = rval * i;
      }

      return rval;
    }
  });
})(Backbone, _, svs);

svs.maltipset.helpers.math = new svs.maltipset.helpers.Math();


 })(window);